
import { 
  Sidebar,
  SidebarContent,
} from "@/components/ui/sidebar";
import { SidebarMain } from "./sidebar/SidebarMain";
import { SidebarLogo } from "./sidebar/SidebarLogo";
import { useIsMobile } from "@/hooks/use-mobile";

export function AppSidebar() {
  const isMobileOrTabletPortrait = useIsMobile(true);

  return (
    <Sidebar className={`bg-[#23486a] text-white md:bg-[#23486a] [&[data-mobile=true]]:!bg-black [&[data-mobile=true]]:!text-white [&[data-mobile=true]]:!w-[80vw] mt-[72px] ${isMobileOrTabletPortrait ? 'mobile-mode' : ''}`}>
      <SidebarContent>
        <SidebarLogo />
        <SidebarMain />
      </SidebarContent>
    </Sidebar>
  );
}
